import React, { useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import {
  ApplicationIconBottom,
  ApplicationIconBottomActive,
  BottomActiveBar,
  ResourceIconBottom,
  ResourceIconBottomActive,
  RolesIconBottom,
  RolesIconBottomActive,
  TeamsIconBottom,
  TeamsIconBottomActive,
} from "../../Icons";
import { useNavigate, useLocation } from "react-router-dom";
import { getPlaceholderName } from "../../utils/general";

const { useUnoSelector } = UnoStoreHooks;

const BottomNavigationBar = () => {
  const userData = useUnoSelector((state) => state.user);
  const isUserAvatar = true;
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      id: "applications",
      label: "Applications",
      icon: <ApplicationIconBottom />,
      iconActive: <ApplicationIconBottomActive />,
      path: `/dashboard/${userData.user.uuid}`,
    },
    {
      id: "team",
      label: "Team",
      icon: <TeamsIconBottom />,
      iconActive: <TeamsIconBottomActive />,
      path: `/team-management/${userData.user.group.uuid}`,
    },
    {
      id: "resource",
      label: "Resource",
      icon: <ResourceIconBottom />,
      iconActive: <ResourceIconBottomActive />,
      path: `/resource-management/${userData.user.group.uuid}`,
    },
    {
      id: "role",
      label: "Role",
      icon: <RolesIconBottom />,
      iconActive: <RolesIconBottomActive />,
      path: "/roles",
    },
    {
      id: "profile",
      label: "Profile",
      isProfile: true,
      path: `/manage/account/${userData.user.uuid}`,
    },
  ];

  const pathMatchers = {
    applications: /^\/dashboard/i,
    team: /^\/team-management/i,
    resource: /^\/resource-management/i,
    role: /^\/roles/i,
    profile: /^\/manage\/account/i,
  };

  const activeNav = Object.keys(pathMatchers).find((key) => pathMatchers[key].test(location.pathname));

  const handleClick = (item) => {
    navigate(item.path);
  };

  return (
    <div className="bottomNavigation">
      <>
        {navItems.map((item) => (
          <div
            key={item.id}
            className={`navigateItem ${activeNav === item.id ? "active" : ""} ${item.isProfile ? "profile" : ""}`}
            onClick={() => handleClick(item)}
          >
            <span className="navigateIcon">
              {item.isProfile ? (
                <>
                  {userData.user.avatar ? (
                    <img src={userData.user.avatar} alt="profile" referrerPolicy="no-referrer" />
                  ) : (
                    <span className="initials"> {getPlaceholderName(userData.user.name)} </span>
                  )}
                </>
              ) : (
                <>{activeNav === item.id ? item.iconActive : item.icon}</>
              )}
            </span>
            <span className="navigateText">{item.label}</span>
            {activeNav === item.id && (
              <span className="activeIndicator">
                <BottomActiveBar />
              </span>
            )}
          </div>
        ))}
      </>
    </div>
  );
};

export default BottomNavigationBar;
